import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import HistoryBlockChain from '../lib/HistoryBlockChain'
import Photos from '../lib/Photos';
import WindowEventHelper from "../lib/WindowEventHelper";
import {getManageHome} from "../utils/UriUtil";

const tiaraLog = (prevLocation, currentLocation) => {
  WindowEventHelper.dispatch('changeStateEvent', {
    prevLocation : prevLocation,
    currentLocation : currentLocation,
    url : `${location.origin}${getManageHome()}`
  })
};

@withRouter
class HistoryChangeListener extends Component {

	componentWillMount() {
		const { history, location } = this.props
		this.unblock = history.block(HistoryBlockChain.blockHandler)
		WindowEventHelper.add("beforeunload", HistoryBlockChain.unloadHandler)
		tiaraLog(null, location)
	}

	componentWillUnmount() {
		this.unblock()
		WindowEventHelper.remove("beforeunload", HistoryBlockChain.unloadHandler)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.location.pathname !== nextProps.location.pathname) {
			window.scrollTo(0, 0)
			tiaraLog(this.props.location, nextProps.location)
			if(Photos.getInstance().isOpen) {
				Photos.getInstance().hide()
			}
		}
	}

	render() {
		const { children } = this.props
		return (
			<div>
				{ children }
			</div>
		)
	}
}

export default HistoryChangeListener
